import(/* webpackMode: "eager", webpackExports: ["Menu"] */ "/app/node_modules/@olinfo/react-components/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["SubmitBatch"] */ "/app/src/app/(training)/task/[name]/submit/batch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubmitOutputOnly"] */ "/app/src/app/(training)/task/[name]/submit/output-only.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageClient"] */ "/app/src/app/(training)/task/[name]/tags/page-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/app/src/components/link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PdfStatement"] */ "/app/src/components/statement/pdf.tsx");
